import { getInitialData } from '../utils/api'
import { receiveEnquiries } from '../actions/enquiries'
import { receiveOffices } from '../actions/offices'
import { receiveUsers } from '../actions/users'
import { setAuthedUser } from '../actions/authedUser'
//import { showLoading, hideLoading } from 'react-redux-loading'

//const AUTHED_ID = null

export function handleInitialData (authedUser) {
	return (dispatch) => {
		//dispatch(showLoading())

		//return loadState()

		return getInitialData(authedUser)
			.then(({ enquiries, offices, users, authedUser }) => {
				dispatch(receiveEnquiries(enquiries))
				dispatch(receiveOffices(offices))
				dispatch(receiveUsers(users))
				dispatch(setAuthedUser(authedUser))
				//dispatch(hideLoading())
			}).then(() => {
				localStorage.authedUserId = authedUser
			})
	}
}


// WEBPACK FOOTER //
// ./src/actions/shared.js